// Generated by Melange

import * as Caml_option from "melange.js/caml_option.jsx";
import * as Curry from "melange.js/curry.jsx";
import * as Js__Js_exn from "melange.js/js_exn.jsx";
import * as Stdlib__Option from "melange/option.jsx";

function Make(Input) {
  const timeout = {
    contents: undefined
  };
  const make = function (arg) {
    return new Promise((function (resolve, reject) {
          const match = timeout.contents;
          if (match !== undefined) {
            return;
          } else {
            timeout.contents = Caml_option.some(setTimeout((function (param) {
              timeout.contents = undefined;
              Curry._1(Input.run, arg).then(function (value) {
                resolve(value);
                return Promise.resolve(undefined);
              }).catch(function (error) {
                reject(Js__Js_exn.anyToExnInternal(error));
                return Promise.resolve(undefined);
              });
            }), Input.ms));
            return;
          }
        }));
  };
  const now = function (arg) {
    Stdlib__Option.iter((function (prim) {
      clearTimeout(prim);
    }), timeout.contents);
    timeout.contents = undefined;
    return Curry._1(Input.run, arg);
  };
  return {
    timeout: timeout,
    make: make,
    now: now
  };
}

export {
  Make,
}
/* Js__Js_exn Not a pure module */
